module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Align-right-0e9c87299e99086bf2c4a064e7e76506.svg";